import React from 'react';
import { Route } from 'react-router-dom';

import LoadingSwitch from 'lib/react-router/loading-switch';
import RouteWithSearch from 'lib/react-router/route-with-search';

import { notAllowedForVendor } from 'four-nets/vendor/permissions';
import NotFound from 'four-nets/errors/404/not-found';
import Group from 'four-nets/photoblog/groups/group/group';

import CreateEditGroup from './create-edit-group/create-edit-group';
import Groups from './groups/groups';

class GroupsRouter extends React.PureComponent {
    render() {
        return (
            <LoadingSwitch>
                <RouteWithSearch path='/list-of-groups/mine' exact={true} component={Groups} />
                <RouteWithSearch path='/list-of-groups' exact={true} component={Groups} />
                <RouteWithSearch path='/new-group/' exact={true} component={CreateEditGroup} />
                <RouteWithSearch path={['/group/:id', '/group/:id/detail']} component={Group} />
                <Route component={NotFound} />
            </LoadingSwitch>
        );
    }
}

export default notAllowedForVendor(GroupsRouter);
